import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { TranslocoDirective, TranslocoService } from '@jsverse/transloco';
import { TuiButton } from '@taiga-ui/core';

@Component({
  selector: 'pxc-saturated-storage',
  templateUrl: './saturated-storage.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  host: {
    class: 'flex flex-col items-center justify-center gap-3',
  },
  imports: [TranslocoDirective, TuiButton],
})
export class SaturatedStorageComponent {
  private readonly translocoService = inject(TranslocoService);

  mailContact = this.translocoService.translate('contact@pixacare.com');
  mailSubject = this.translocoService.translate('Limite de stockage atteinte');
  mailBody = this.translocoService.translate(
    `Bonjour, 
    J'aimerais supprimer la limite de stockage imposée sur l'application, pouvez-vous m'aider ? 
    Cordialement,`,
  );

  get mailHref(): string {
    return `mailto:${this.mailContact}
    ?subject=${encodeURIComponent(this.mailSubject)}
    &body=${encodeURIComponent(this.mailBody)}`;
  }
}
